import { render, staticRenderFns } from "./CargoExpenseKanban.vue?vue&type=template&id=9fd25890&scoped=true"
import script from "./CargoExpenseKanban.vue?vue&type=script&lang=js"
export * from "./CargoExpenseKanban.vue?vue&type=script&lang=js"
import style0 from "./CargoExpenseKanban.vue?vue&type=style&index=0&id=9fd25890&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd25890",
  null
  
)

export default component.exports